module.exports = __webpack_public_path__ + "portal-static/img/word.db688180.png";